<template>
  <router-view />
</template>

<script>
export default {
  name: 'EquipmentStoragePurchaseItemsIndex'
}
</script>
